module.exports = __webpack_public_path__ + "img/arrow-green.f273a2ba.svg";